<template>
  <div class="home_bg">
    <Slider />
    <Content />
  </div>
</template>
<script>
  import Slider from '@/components/Slider';
  import Content from '@/components/Content';

  export default {
    components: {
      Slider,
      Content,
    },
  };
</script>


<style lang="less">
.home_bg {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue